import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const CONTACT_KEEP_IN_TOUCH_QUERY_KEY = 'contact-keep-in-touch';

const getQueryFn =
	({
		contactId,
		userSession,
		impersonationContext,
	}: {
		contactId: string;
		allowArchived?: boolean;
		expandHouseholdMembers?: boolean;
		userSession: Api.UserSessionContext;
		impersonationContext?: Api.IImpersonationContext;
	}) =>
	async () => {
		return userSession.webServiceHelper.callAsync<Api.IKeepInTouch>(
			Api.ImpersonationBroker.composeApiUrl({
				urlPath: `keepintouch/byContact/${contactId}/me`,
				impersonationContext,
			}),
			'GET'
		);
	};

export const useContactKeepInTouchQuery = ({ contactId, enabled = true }: { contactId: string; enabled?: boolean }) => {
	const userSession = useUserSession();
	return useQuery({
		queryFn: getQueryFn({ contactId, userSession }),
		queryKey: [CONTACT_KEEP_IN_TOUCH_QUERY_KEY, { contactId }],
		enabled,
		retry: false,
	});
};
